
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

const getAll = async (params = {} ) => {

  const query = `
    query AllAuxmed(
      $search          : String,
      $tokenAuxiliar   : String, 
      $establecimiento : String,
      $tipoAuxiliar    : String,
      $page            : Int, 
      $pageSize        : Int
    ) {
      allAuxmed(
        search         : $search, 
        tokenAuxiliar  : $tokenAuxiliar,
        establecimiento: $establecimiento,
        tipoAuxiliar   : $tipoAuxiliar,
        page           : $page, 
        pageSize       : $pageSize
      ) {
        total
        status
        message
        auxiliar {
          estado
          fechaCreacion
          id
          token
          ultimoCambio
          fechainicio
          fechafin
          activo
          idPersona {
            identificacion
            primerNombre
            primerApellido
            segundoApellido
            segundoNombre
            identificacion
            detalleusuarioSet {
              usuario {
                id
                username
              }
            }
          }
          tipoauxiliar {
            id
            descripcion
          }
        }
      }
    }
  `;
  
  const variables = {
    ...params
  }

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.allAuxmed;
    if( response2.status !== 'success' ) return null;

    const auxiliaresMap = response2.auxiliar.map(item => ({
      ...item,
      value: item.id,
      text: `${item.idPersona.primerApellido} ${item.idPersona.primerNombre}`
    }))

    const data = {
      total     : response2.total,
      auxiliares: auxiliaresMap
    }

    return data;

  }catch(error){
    console.error('Error al obtener auxiliares medicos', error);
    return null;
  }
}



const getTipos = async () =>{

  const query = `
    query MyQuery {
      allTipoEspecialidades {
        descripcion
        id
      }
    }
  `;

  try{

    const response = await axios.post(rutas.axios + 'api', { query });
    const data = response.data.data.allTipoEspecialidades;

    const dataMap = data.map(item => ({
      value: item.id,
      text: item.descripcion
    }));

    return dataMap;

  }catch(error){
    console.error('Error al obtener auxiliares medicos', error);
    return null;
  }
}



const registrar = async (params = {}) => {

  const query = `
    mutation CrearAuxiliarMedico(
      $auxiliarMedicoData: AuxiliarMedicoInput!
    ) {
      crearAuxiliar(
        auxiliarMedicoData: $auxiliarMedicoData
      ) {
        auxiliar {
          id
          token
        }
        message
        status
      }
    } 
  `;

  const variables = {
    ...params
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.crearAuxiliar;
    if( response2.status !== 'success' ) return null;

    const data = response2.auxiliar;
    return data;
    
  }catch(error){
    console.error('Error al registrar auxiliar medico', error);
    return null;
  }
}


export const auxiliarMedicoService = {
  getAll,
  getTipos,
  registrar
}